module.exports = __webpack_public_path__ + "img/logo.f0dbf6a1.png";